import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import { getFirestore } from "firebase/firestore";
//import { getAnalytics } from "firebase/analytics";

const app = firebase.initializeApp({
  apiKey: "AIzaSyAGvmJrDZXXnxGvYn0bGihXYduqf6kMabc",
  authDomain: "bejour-fe268.firebaseapp.com",
  projectId: "bejour-fe268",
  storageBucket: "bejour-fe268.appspot.com",
  messagingSenderId: "408034094493",
  appId: "1:408034094493:web:8642f356c41c4a43f39374",
  measurementId: "G-6K312MBYZT",
});

export const auth = app.auth();
//export const analytics = getAnalytics();
export const storage = app.storage();
export const db = getFirestore();

export default app;
